export function isApiErrorBody(value) {
    return (typeof value === 'object' &&
        value !== null &&
        'statusCode' in value &&
        'code' in value &&
        'message' in value);
}
//# sourceMappingURL=api-error.js.map